import {Injectable, Type} from '@angular/core';

import {HttpClient} from "@angular/common/http";
import {
    BmCreditorObjectComponent
} from "../../component/object-components/bm-creditor-object-component/bm-creditor-object.component";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {MvsCrudModeEnum} from "../../../../core/shared/service/crud/mvs-crud-mode.enum";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CreditorService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/bm/creditors')
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        if (mode != MvsCrudModeEnum.create) {
            return BmCreditorObjectComponent;
        }
        return null;
    }

    /**
     * Trigger the creditor-wide auto-assignment job for all open transactions across every bank
     * account of the given creditor (POST /mvsa/bm/creditors/{id}/jobAutoAssignTransactions).
     */
    autoAssignTransactions(creditorId: number): Observable<any> {
        return this.postBasic({}, `/${creditorId}/jobAutoAssignTransactions`);
    }

    /**
     * Trigger the creditor-scoped manual import of all pending CAMT documents for the given creditor
     * (POST /mvsa/bm/creditors/{id}/jobImportPendingDocuments). The import runs asynchronously; the
     * backend returns 200 immediately.
     */
    importPendingDocumentsForCreditor(creditorId: number): Observable<any> {
        return this.postBasic({}, `/${creditorId}/jobImportPendingDocuments`);
    }
}